import React from 'react';
import { Outlet } from 'react-router-dom';

// @mui
import { styled } from '@mui/material/styles';
import Nav from './nav';
import Header from './header';

// ----------------------------------------------------------------------
const APP_BAR_MOBILE = 70; // on mobile provide space for top menu bar
const APP_BAR_DESKTOP = 40; // on desktop provide space for top menu bar

const StyledRoot = styled('div')({
    display: 'flex',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden'
});

const Main = styled('div')(({ theme, noPadding = false }) => ({
    flexGrow: 1,
    overflow: 'auto',
    height: '100%',
    background: theme.palette.background.paper,
    paddingTop: APP_BAR_MOBILE,
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.up('lg')]: {
        paddingTop: noPadding ? 0 : APP_BAR_DESKTOP,
        paddingLeft: noPadding ? 0 : theme.spacing(2),
        paddingRight: noPadding ? 0 : theme.spacing(2)
    },
    [theme.breakpoints.up('xl')]: { maxWidth: '100vw' }
}));

// ----------------------------------------------------------------------

export default class MainLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        };
    }

    render() {
        const { location } = this.props;

        const routesWithoutPadding = [
            '/app/marketing-campaigns/add',
            '/app/marketing-campaigns/update/:id'
        ];

        const noPadding = routesWithoutPadding.some((route) =>
            location.pathname.startsWith(route.replace(':id', ''))
        );
        return (
            <StyledRoot>
                <>
                    <Header onOpenNav={() => this.setState({ open: true })} />

                    {
                        <Nav
                            openNav={this.state.open}
                            onCloseNav={() => this.setState({ open: false })}
                        />
                    }

                    <Main noPadding={noPadding}>
                        <Outlet />
                    </Main>
                </>
            </StyledRoot>
        );
    }
}
